export const HIDDEN_IMPORT_MESSAGES = [
  "feed senza sconto distinto: prezzi identici nel campione",
];

export function filterHiddenImportMessages(messages) {
  if (!Array.isArray(messages)) {
    return [];
  }
  return messages.filter(
    (message) =>
      message &&
      !HIDDEN_IMPORT_MESSAGES.some(
        (hidden) => hidden.localeCompare(String(message).trim(), "it", { sensitivity: "accent" }) === 0
      )
  );
}

export const IMPORT_STAT_FIELDS = [
  {
    key: "totalProducts",
    snakeKey: "total_products",
    label: "Prodotti nel feed",
    tooltip:
      "Quanti prodotti erano presenti nel file o nel feed analizzato in questo import.",
  },
  {
    key: "productsImported",
    snakeKey: "products_imported",
    label: "Prodotti aggiornati",
    tooltip:
      "Prodotti il cui contenuto è stato scritto o modificato nel catalogo durante questo import.",
  },
  {
    key: "unchangedProducts",
    snakeKey: "unchanged_products",
    label: "Prodotti invariati",
    tooltip:
      "Prodotti già presenti con gli stessi dati: non è stato necessario aggiornarli.",
  },
  {
    key: "productsWithErrors",
    snakeKey: "products_with_errors",
    label: "Prodotti con errori",
    tooltip:
      "Righe del feed non importate per problemi sui dati obbligatori o sul formato.",
    highlight: "error",
  },
  {
    key: "productsWithWarnings",
    snakeKey: "products_with_warnings",
    label: "Prodotti con avvisi",
    tooltip:
      "Righe con segnalazioni non bloccanti: conviene controllarle, ma l'import è andato avanti.",
    highlight: "warning",
  },
  {
    key: "newProducts",
    snakeKey: "new_products",
    label: "Nuovi prodotti",
    tooltip: "Prodotti non presenti in precedenza e aggiunti al catalogo con questo import.",
  },
  {
    key: "deactivatedProducts",
    snakeKey: "deactivated_products",
    label: "Prodotti disattivati",
    tooltip:
      "Prodotti resi non visibili perché assenti dal feed o marcati come disattivati.",
  },
  {
    key: "undeactivatedProducts",
    snakeKey: "undeactivated_products",
    label: "Prodotti riattivati",
    tooltip: "Prodotti tornati visibili perché ricompaiono nel feed o sono stati riattivati.",
  },
  {
    key: "deletedProducts",
    snakeKey: "deleted_products",
    label: "Prodotti eliminati",
    tooltip: "Prodotti rimossi dal catalogo in seguito a questo import.",
  },
  {
    key: "undeletedProducts",
    snakeKey: "undeleted_products",
    label: "Prodotti ripristinati",
    tooltip: "Prodotti precedentemente eliminati e rimessi disponibili con questo import.",
  },
];

export function normalizeImportStatistics(raw) {
  if (!raw || typeof raw !== "object") {
    return null;
  }

  const read = (camel, snake) => {
    const value = raw[camel] ?? raw[snake];
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const readList = (camel, snake) => {
    const value = raw[camel] ?? raw[snake];
    return Array.isArray(value) ? value.map(String) : [];
  };

  return {
    totalProducts: read("totalProducts", "total_products"),
    productsImported: read("productsImported", "products_imported"),
    unchangedProducts: read("unchangedProducts", "unchanged_products"),
    productsWithErrors: read("productsWithErrors", "products_with_errors"),
    productsWithWarnings: read("productsWithWarnings", "products_with_warnings"),
    newProducts: read("newProducts", "new_products"),
    deactivatedProducts: read("deactivatedProducts", "deactivated_products"),
    undeactivatedProducts: read("undeactivatedProducts", "undeactivated_products"),
    deletedProducts: read("deletedProducts", "deleted_products"),
    undeletedProducts: read("undeletedProducts", "undeleted_products"),
    globalErrors: filterHiddenImportMessages(readList("globalErrors", "global_errors")),
    globalWarnings: filterHiddenImportMessages(readList("globalWarnings", "global_warnings")),
  };
}

export function normalizeImportIssue(raw) {
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const issueType = String(raw.issueType ?? raw.issue_type ?? "error").toLowerCase();
  const message = raw.colonneErrori ?? raw.colonne_errori ?? "";
  if (!message || filterHiddenImportMessages([message]).length === 0) {
    return null;
  }
  const rowIndex = raw.rowIndex ?? raw.row_index;
  return {
    rowIndex: rowIndex == null ? null : rowIndex,
    colonneErrori: message,
    issueType: issueType === "warning" ? "warning" : "error",
    uuidRow: raw.uuidRow ?? raw.uuid_row,
  };
}

export function normalizeImportIssues(rawList) {
  if (!Array.isArray(rawList)) {
    return [];
  }
  return rawList.map(normalizeImportIssue).filter(Boolean);
}
